<script lang="ts">
  import { createQuery } from '@tanstack/svelte-query';
  import { Activity } from 'lucide-svelte';
  import { adminActivityApi } from '$lib/api/admin';
  import { getErrorMessage } from '$lib/api/client';

  const activityQuery = createQuery(() => ({
    queryKey: ['admin-activity'],
    queryFn: () => adminActivityApi.list()
  }));
</script>

<div class="tym-page">
  <div class="mb-[18px]">
    <h2 class="tym-section-title">Activity</h2>
    <div class="tym-section-sub">
      Most recent 50 events &middot; quote duplication, share links, client comments, search
    </div>
  </div>

  {#if activityQuery.isLoading}
    <p class="tym-loading-state">Loading activity&hellip;</p>
  {:else if activityQuery.isError}
    <p class="tym-error-state">{getErrorMessage(activityQuery.error)}</p>
  {:else if activityQuery.data}
    <div class="flex max-w-[720px] flex-col gap-2.5">
      {#each activityQuery.data.results as row (row.id)}
        <div class="tym-card flex items-start gap-[13px] px-[18px] py-[15px]">
          <span
            class="flex h-9 w-9 shrink-0 items-center justify-center rounded-[11px] bg-toyama-teal/10 text-toyama-teal"
          >
            <Activity class="h-[18px] w-[18px]" />
          </span>
          <div class="min-w-0 flex-1">
            <div class="text-[14px] text-navy">{row.description}</div>
            <div class="mt-0.5 text-xs text-dark-gray">
              {new Date(row.created_at).toLocaleString()}
              {#if row.user_name}by {row.user_name}{/if}
            </div>
          </div>
        </div>
      {:else}
        <p class="tym-empty-state">No activity yet.</p>
      {/each}
    </div>
  {/if}
</div>
